module.exports = __webpack_public_path__ + "static/cartabsFrontLayout2-94b052302f819c91dbf051a5e0577c6d.png";